import React, { useState, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import './ModalInicial.css';

const ModalInicial = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-inicial" centered>
      <ModalBody className="p-0">
        <button
          type="button"
          className="close modal-close-button"
          onClick={toggle}
          aria-label="Fechar"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <img
          src="/imagem-modal.jpeg"
          alt="Comunicado Leo Acrílicos"
          className="img-fluid w-100"
        />
      </ModalBody>
    </Modal>
  );
};

export default ModalInicial;
